import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getCurrentRef } from '@vista-digital/react-tools';
import { memo, useCallback, useContext, useRef } from 'react';
import { ZoomController } from '../../zoom-controller/zoom-controller';
import { getMapRectangle, getMapScaleFactor } from '../positioning/map';
import { SeatPickerContextInstance } from '../types/context';
import { SeatPickerMap } from './map';
import { SeatPickerRowLabels } from './row-labels';
const b = bemClassBuilder('v-seat-picker-zoom-controller');
export const SeatPickerZoomController = memo(() => {
    const { data, config, isDisabled } = useContext(SeatPickerContextInstance);
    const { seatLayout } = data;
    const rowLabelsRef = useRef(null);
    const handleScrollPositionChanged = useCallback((scrollPosition) => {
        updateRowLabelsClass(rowLabelsRef, scrollPosition);
    }, []);
    const scaleFactor = getMapScaleFactor(seatLayout, config);
    const mapRectangle = getMapRectangle(scaleFactor, seatLayout.boundary, config);
    const rowLabelsWidth = config.rowLabels.size + config.rowLabels.margin * 2;
    const totalWidth = mapRectangle.width + rowLabelsWidth;
    return (_jsxs(ZoomController, { className: b.block(), contentDimensions: { width: totalWidth, height: mapRectangle.height }, showPanButtons: config.navigation.showPanButtons, showZoomButtons: config.navigation.showZoomButtons, zoomButtonsPosition: config.navigation.zoomButtonsPosition, onScrollPositionChange: handleScrollPositionChanged, isDisabled: !!isDisabled, children: [_jsx("div", { className: b.element('row-labels', { disabled: isDisabled }), ref: rowLabelsRef, style: { width: `${(rowLabelsWidth / totalWidth) * 100}%` }, children: _jsx(SeatPickerRowLabels, { seatLayout: seatLayout, scaleFactor: scaleFactor, mapRectangle: mapRectangle, width: rowLabelsWidth }) }), _jsx("div", { className: b.element('map', { disabled: isDisabled }), style: { width: `${(mapRectangle.width / totalWidth) * 100}%` }, children: _jsx(SeatPickerMap, { data: data, rectangle: mapRectangle, scaleFactor: scaleFactor }) })] }));
});
SeatPickerZoomController.displayName = 'SeatPickerZoomController';
const updateRowLabelsClass = (rowLabelsRef, scrollPosition) => {
    const rowLabels = getCurrentRef(rowLabelsRef);
    const fixedClass = 'v-seat-picker-zoom-controller__row-labels--is-fixed';
    const isFixed = scrollPosition.x > 0;
    if (isFixed) {
        rowLabels.classList.add(fixedClass);
    }
    else {
        rowLabels.classList.remove(fixedClass);
    }
};
//# sourceMappingURL=zoom-controller.js.map